import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: '0.5rem',
    border: 'none',
    width: '50%',
    outline: 'none',
    paddingTop: 6
  },

  transparent: {
    paddingLeft: '24px',

    '& > div > input': {
      border: 'none',
      width: '75%',
      padding: '0',
      outline: 'none',
      backgroundColor: 'white'
    },

    '& > div > input:focus': {
      boxShadow: 'none',
      borderColor: 'none'
    }
  },

  button: {
    display: 'flex',
    alignItems: 'center',
    color: 'grey',
    cursor: 'pointer',
    padding: '6px 0px 6px 24px',
    fontSize: theme.size.sm
  },

  icon: {
    color: 'grey',
    marginRight: '0.5rem'
  }
}))

export default useStyles
